<template>
  <Img :asset="asset" />
</template>

<script>
import Img from "@/components/components/Img";

export default {
  name: "ImgBlock",
  components: {Img},
  props: {
    asset: String,
  }
};
</script>

<style scoped>
img {
  margin: 24px 0 0 0;
}
</style>